import React from "react";

import Background from "./settingable/Background";
import Border from "./settingable/Border";
import Font from "./settingable/Font";
import Padding from "./settingable/Padding";
import TextAlign from "./settingable/TextAlign";
import Visibility from "./settingable/Visibility";
import Html from "./settingable/Html";

export default (...args) => Component => {
  const settings = args.length === 0 ? [] : args;
  const SettingableComponent = props => {
    const { selectedNode, selected, update, scrollToIfNeeded } = props;
    const onChange = (...args) => {
      if (args[0] instanceof Object) {
        return update(selected, args[0]);
      }

      update(selected, { [args[0]]: args[1] });
    };

    return (
      <>
        {settings.includes("html") && (
          <Html node={selectedNode} />
        )}
        {settings.includes("background") && (
          <Background
            node={selectedNode}
            onChange={onChange}
            scrollToIfNeeded={scrollToIfNeeded}
            field={
              selectedNode.background !== undefined
                ? "background"
                : "css_background"
            }
          />
        )}
        <Component {...props} />
        {settings.includes("font") && (
          <Font
            node={selectedNode}
            onChange={onChange}
            scrollToIfNeeded={scrollToIfNeeded}
          />
        )}
        {settings.includes("text-align") && (
          <TextAlign node={selectedNode} onChange={onChange} />
        )}
        {settings.includes("border-color") && (
          <Border
            node={selectedNode}
            onChange={onChange}
            scrollToIfNeeded={scrollToIfNeeded}
          />
        )}
        {settings.includes("background-color") && (
          <Background
            node={selectedNode}
            onChange={onChange}
            onlyColor={true}
            scrollToIfNeeded={scrollToIfNeeded}
          />
        )}
        {settings.includes("visibility") && props.settings && (
          <Visibility node={selectedNode}
            onChange={onChange}
            recipientParameters={props.settings.recipient_parameters}
          />
        )}
        {settings.includes("padding") && (
          <Padding node={selectedNode} onChange={onChange} />
        )}
      </>
    );
  };

  return SettingableComponent;
};
